import { FC } from 'react';
import styled from 'styled-components';

export type StatusBadgeType = 'new' | 'newVersion' | 'duplicate' | 'updated';

const LABEL: Record<StatusBadgeType, string> = {
  new: 'NEW',
  newVersion: 'New version',
  duplicate: 'Duplicate',
  updated: 'Updated',
};

const StyledBadge = styled.span<{ $type: StatusBadgeType; $compact?: boolean }>`
  display: inline-block;
  white-space: nowrap;
  padding: ${({ $compact }) => ($compact ? '1px 6px' : '2px 10px')};
  border-radius: ${({ $compact }) => ($compact ? '8px' : '12px')};
  font-size: ${({ $compact }) => ($compact ? '9px' : '12px')};
  line-height: ${({ $compact }) => ($compact ? '1.3' : 'normal')};
  font-weight: 500;
  background-color: ${({ theme, $type }) => theme.slides.statusBadge[$type].background};
  color: ${({ theme, $type }) => theme.slides.statusBadge[$type].color};
  border: 1px solid ${({ theme, $type }) => theme.slides.statusBadge[$type].color};
`;

export const StatusBadge: FC<{ $type: StatusBadgeType; $compact?: boolean }> = ({ $type, $compact }) => (
  <StyledBadge $type={$type} $compact={$compact}>
    {LABEL[$type]}
  </StyledBadge>
);
